/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  ListMonitorIncidentsQueryResponse,
  ListMonitorIncidentsPathParams,
  ListMonitorIncidentsQueryParams,
  ListMonitorIncidents401,
  ListMonitorIncidents404,
} from '../types/ListMonitorIncidents.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getListMonitorIncidentsUrl(id: ListMonitorIncidentsPathParams['id']) {
  const res = { method: 'GET', url: `/v1/monitors/${id}/incidents` as const };
  return res;
}

/**
 * @summary List incidents for a monitor
 * {@link /v1/monitors/:id/incidents}
 */
export async function listMonitorIncidents(
  id: ListMonitorIncidentsPathParams['id'],
  params?: ListMonitorIncidentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    ListMonitorIncidentsQueryResponse,
    ResponseErrorConfig<ListMonitorIncidents401 | ListMonitorIncidents404>,
    unknown
  >({ method: 'GET', url: getListMonitorIncidentsUrl(id).url.toString(), params, ...requestConfig });
  return res.data;
}
